import React, { useEffect } from 'react';
//componets
import FlNav from './landingComponents/Navbar';
import FlFooter from './landingComponents/Footer';

import icn_vision from '../../assets/img/landingPage/about/aboutUs_vision.svg';

//Mansory - Bento grid
import Masonry from 'react-masonry-css';

//Iconos
import icn_01 from '../../assets/img/landingPage/financial/icn_financial_06.png';
import icn_02 from '../../assets/img/landingPage/integration/icn_integration_06.png';
import icn_03 from '../../assets/img/landingPage/cloudP/icn_cp_02.png';
import icn_04 from '../../assets/img/landingPage/management/icn_management_08.png';

//key features
import key01 from '../../assets/img/landingPage/logistics/logistics-05.png'
import key02 from '../../assets/img/landingPage/manufacturing/manufacturing-02.png'
import key03 from '../../assets/img/landingPage/manufacturing/manufacturing-03.png'
import key04 from '../../assets/img/landingPage/retail/retail_02.png'
import key05 from '../../assets/img/landingPage/connectors/Connectors_01.png'

import fondo from '../../assets/img/landingPage/fondo.png';
import ReactGA from 'react-ga4'

import Favicon from '../../assets/img/Favicon_AVAP_Framework.png'

//Importaciones de otros archivos, revisar y borrar
import gradientApi from '../../assets/img/landingPage/gradientApi.png'
import gradientServices from '../../assets/img/landingPage/gradientServices.png'


import dashboard from '../../assets/img/landingPage/cloud/Cloud-home.png';


const Manufacturing = () => {


    useEffect(() =>{

        if (/*config.url != 'https://avs-primary-pre.101obex.mooo.com' &&*/ true){
            ReactGA.initialize('G-08SZKPG9V0');
            ReactGA.send({ hitType: 'pageview', page: window.location.pathname, title: '101OBEX, CORP About Page' });
            }

    }, [])


    useEffect(() =>{

        if (/*config.url != 'https://avs-primary-pre.101obex.mooo.com' &&*/ true){
            ReactGA.initialize('G-08SZKPG9V0');
            ReactGA.send({ hitType: 'pageview', page: window.location.pathname, title: '101OBEX, CORP About Page' });
            }

    }, [])

    useEffect(() => {
        // favicon 
        const link = document.createElement('link');
        link.rel = 'icon';
        link.href = Favicon; // Usa la ruta importada directamente
        document.head.appendChild(link);
    
        // clean favicon 
        return () => {
          document.head.removeChild(link);
        };
      }, []);

    useEffect(() => {

        document.body.classList.add('dark-bg');
        return () => {
            document.body.classList.remove('dark-bg');
        };

    }, []);

    const productDetailsA = {
        Key_Feature_01: {
            title: 'Streamline Supply Chain Connectivity',
            text: "Easily connect ERP, inventory, and logistics systems to gain real-time insights across suppliers, distributors, and factories.",
            altDescription: "Easily connect ERP, inventory, and logistics systems to gain real-time insights across suppliers, distributors, and factories.",
            image: key01,
        },
        Key_Feature_02: {
            title: "Automate Manufacturing Operations",
            text: "Accelerate production planning, maintenance, and quality control using low-code workflows and event-driven APIs.",
            altDescription: "Accelerate production planning, maintenance, and quality control using low-code workflows and event-driven APIs.",
            image: key02,
        },
        Key_Feature_03: {
            title: 'Improve Decision-Making',
            text: 
            "Unify disconnected data from across the value chain to support analytics, forecasting, and agile manufacturing strategies.",
            altDescription: 'Unify disconnected data from across the value chain to support analytics, forecasting, and agile manufacturing strategies.',
            image: key03,
        },
        Key_Feature_04: {
            title: 'Secure and Scalable Integration',
            text: 
            "Use AVAP Framework’s API management layer to safely expose data and processes, with governance, versioning, and audit control built in.",
            altDescription: 'Unify disconnected data from across the value chain to support analytics, forecasting, and agile manufacturing strategies.',
            image: key04,
        },
        Key_Feature_05: {
            title: 'Modernize Without Replacing',
            text: 
            "Connect legacy systems with new digital applications using adapters and prebuilt connectors, without costly replacements or disruptions.",
            altDescription: 'Connect legacy systems with new digital applications using adapters and prebuilt connectors, without costly replacements or disruptions.',
            image: key05,
        },
    }

     //Key Benefits Bento
     const items = [
        {
          icon: icn_01,
          title: 'IT Leaders',
          paragraphs: [
            'Eliminate integration backlog and enable faster delivery.',
        ]
        },
        {
          icon: icn_02,
          title: 'Operations Teams',
          paragraphs: [
            'Monitor and automate production and supply chain processes.',
          ]
        },
        {
          icon: icn_03,
          title: 'Engineering Teams',
          paragraphs: [
            'Reuse standardized APIs across systems and factories.',
          ]
        },
        {
            icon: icn_04,
            title: 'Partner Ecosystem',
            paragraphs: [
              'Provide real-time data access for suppliers and distributors.',
            ]
          },
    ];

    const breakpointColumnsObj = {
        default: 4, //Cambio de columnas verticales
        1100: 2,
        700: 1
      
    };

    
    return (
        <>
            <FlNav></FlNav>
            <div id="pricing"
            className="fl-cloud-product bg-black text-white"
            style={{ backgroundImage: `url(${fondo})` }}
            >
                {/* Hero Section */}
                <section id="heroProduct" 
                className="text-center py-5">
                    <h1 className="fl-title-big m-0">AVAP for Manufacturing</h1>
                    <p className="fl-title m-0 gradient-text">Accelerate your supply chain. Connect systems, <br />factories, and partners. All with APIs.</p>
                               
                                {/*Boton Contact Us*/}  
                                <a className="glowBtn-dark " style={{zIndex: 2}} href="/contact" target='_blank'><span className="btnInner">   Contact Us  </span></a>
                    
                </section>

                {/* Subtítulo descripción */}
                <section className="text-center pb-5">
                    {/*<img
                        src={dashboard}
                        className="img-fluid mt-5 pb-6"
                        style={{ width: '70%', maxWidth: '800px', height: 'auto' }}
                    />*/}
                     <p className="fl-text fl-txt-container-s" >
                                AVAP Framework helps manufacturers modernize operations, optimize the supply chain, and unlock real-time visibility by connecting ERP, MES, logistics, and customer systems through modular APIs and automation.
                                </p>
                </section>
                
                <div className="container text-center fl-card-border pb-8">
                <h2 className="fl-title m-0 gradient-text fl-title m-4">Why AVAP for Manufacturing?</h2>
                    <p className="fl-text text-center fl-txt-container-s">
                     Reduce costs, improve quality, and respond to market changes faster.
                     With AVAP, your teams can unify systems, automate workflows, and expose services securely across the ecosystem, all from a single, scalable platform.
                    </p>
                    <br />
                        <ul className="fl-bullets fl-text text-center .fl-txt-container-s">
                        <li className="fl-bullets">Simplify integration across ERP, CRM, MES, and IoT systems</li>
                        <li className="fl-bullets">Automate operations with low-code workflows and reusable APIs</li>
                        <li className="fl-bullets">Accelerate product delivery with real-time supply chain visibility</li>
                        <li className="fl-bullets">Enable B2B connectivity with secure, standards-based APIs</li>
                        <li className="fl-bullets">Support global operations with hybrid cloud and on-premise deployments</li>
                        </ul>
                </div>
                
                {/* Sección Key Features */}
                <div className="fl-wrapper">
                    <img src={gradientServices} className="gradient gradientServices" alt="" />
                    <img src={gradientApi} alt="" className="gradient gradientlife" />
                    <div className="fl-container">
                        <section id="products">
                            {/*   <h3 className="fl-title text-center">Our Products & Services</h3> */}
                            <p className="fl-title m-0">Key Capabilities</p>
                            <div className="fl-productsWrapper">
                                {Object.keys(productDetailsA).map((productKey, index) => (
                                    <div key={productKey} className="fl-product-item">
                                        <div className={`row align-items-center ${index % 2 === 0 ? '' : 'flex-row-reverse'}`}>
                                            <div className="col-md-6">
                                                <div className="product-content">
                                                    <h3 className="fl-subtitle">
                                                        {productDetailsA[productKey].title}
                                                    </h3>
                                                    <p className="fl-text">
                                                        {productDetailsA[productKey].text}
                                                    </p>
                                                    
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <img
                                                    src={productDetailsA[productKey].image}
                                                    alt={productDetailsA[productKey].altDescription}
                                                    className="img-fluid product-preview"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </section>
                    </div>
                </div>

                {/*MASONRY 2 COLUMNAS, ICONO CENTRADO, FONDO GRIS, TITULO Y PÁRRAFO */}
                <div className="container">
                <div className="fl-title text-center mb-5">
                    Built for Manufacturing Teams
                    </div>
                    <Masonry
                    breakpointCols={breakpointColumnsObj}
                    className="masonry-grid"
                    columnClassName="masonry-column"
                    >
                    {items.map((item, idx) => (
                        <div key={idx} className="fl-card-s text-center grayBox">
                        <img src={item.icon} alt="Icon representing 0X" className="solutionsIcon" />
                        <p className="fl-subtitle-xs">{item.title}</p>
                        {item.paragraphs.map((p, i) => (
                            <p key={i} className="fl-text">{p}</p>
                        ))}
                        </div>
                    ))}
                    </Masonry>
                </div>

                {/* Sección Key Benefits */}   
               {/* <section className="container fl-z-index-2 position-relative mb-8">
                    <div className="row">
                        <div className="col  mb-5">
                            <div className="fl-title text-center mb-3">
                            Built for Manufacturing Teams
                            </div>
                        </div>
                    </div>
                    <div className="row ">
                        <div className="col-md-4">
                            <div className="fl-card grayGradient">
                                
                                <img
                                src={icn_vision}
                                alt="Icon representing 01."
                                className="mb-3 aboutIcon"
                                />
                                
                                <p className="fl-subtitle-xs">
                                IT Leaders
                                </p>
                                <p className="fl-text">
                                Eliminate integration backlog and enable faster delivery

                                </p>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="fl-card grayGradient">
                                
                                <img
                                src={icn_vision}
                                alt="Icon representing 01."
                                className="mb-3 aboutIcon"
                                />
                                <p className="fl-subtitle-xs">
                                Operations Teams
                                </p>
                                <p className="fl-text">
                                Monitor and automate production and supply chain processes
                                    <br />&nbsp;
                                </p>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="fl-card grayGradient">
                               
                                <img
                                src={icn_vision}
                                alt="Icon representing 01."
                                className="mb-3 aboutIcon"
                                />
                                <p className="fl-subtitle-xs">
                                Engineering Teams
                                </p>
                                <p className="fl-text">
                                Reuse standardized APIs across systems and factories
                                </p>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="fl-card grayGradient">
                                
                                <img
                                src={icn_vision}
                                alt="Icon representing 01."
                                className="mb-3 aboutIcon"
                                />
                                <p className="fl-subtitle-xs">
                                Partner Ecosystem
                                </p>
                                <p className="fl-text">
                                Provide real-time data access for suppliers and distributors
                                </p>
                            </div>
                        </div>
                    </div>
                </section>*/}

                {/* Sección built for secure */} 
                <section className="container">
                    <div className="row">
                        <div className="col">
                            <div className="blobContainer mb-8 mt-4">

                                <div className="blob"></div>
    

                                <div className="">
                                    <h3 className='fl-title text-center'>Explore AVAP Cloud for Manufacturing</h3>
                                    <p>
                                    <ul className="fl-bullets fl-text text-center">
                                    <li className="fl-bullets">Virtual APIs</li>
                                    <li className="fl-bullets">Pre-built ERP and MES connectors</li>
                                    <li className="fl-bullets">Developer-friendly tools</li>
                                    <li className="fl-bullets">Multi-cloud and on-premise ready</li>
                                    <li className="fl-bullets">Full governance and observability</li>
                                    </ul>
                                    {/*Boton Contact Us*/}  
                                    <a className="glowBtn-dark " 
                                    style={{ zIndex: 2}} 
                                    href="/contact" 
                                    target='_blank'><span className="btnInner">   Contact Us  </span></a> 
                                    </p>

                                </div>
                            </div>
                        </div>
                    </div>
                </section>

            </div>
            <FlFooter></FlFooter>
        </>
    );
};

export default Manufacturing;
